import React, {Component} from 'react';
import {Route, Link} from 'react-router-dom';
import {toastr} from 'react-redux-toastr';
import PrivateAPIResource from "../../services/PrivateAPIResource";
import { injectIntl } from 'react-intl';
import {messages} from '../common/Translations';

class UserDelete extends React.Component {

    constructor(props) {
        super(props);
    }

    confirmDelete() {
        let data = {
            deactivate: true,
        };

        const promise = PrivateAPIResource.update('del-accounts', this.props.userId, data);

        promise
            .then(response => {
                this.addAlert(this.props.intl.formatMessage(messages.success), response.message);
            })
            .catch(err => {
                this.addAlert(this.props.intl.formatMessage(messages.userDeleteProfileError), err.message, false);
            });
    }

    addAlert(title, text, success = true) {
        if(!success) {
            return toastr.error(title, text);
        }

        return toastr.success(title, text);
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12"><h1>{this.props.intl.formatMessage(messages.userDeleteMyProfile)}</h1></div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-block">
                                <blockquote className="blockquote">
                                    <p>{this.props.intl.formatMessage(messages.userDeleteProfileDescription)}</p>
                                    <button onClick={this.confirmDelete.bind(this)} type="button" className="btn btn-secondary waves-effect list-action">{this.props.intl.formatMessage(messages.userDeleteMyProfile)}</button>
                                </blockquote>
                                <hr />
                                <div className="row" style={{fontSize: '20px'}}>
                                    <div className="col-12">
                                        <p>{this.props.intl.formatMessage(messages.userWantDownload)}</p>
                                        <p><Link to="/user/profil">{this.props.intl.formatMessage(messages.userDownloadData)}</Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(UserDelete);


// WEBPACK FOOTER //
// ./web/src/components/users/UserDelete.jsx